<template>
    <div>
        <div id="overlay"></div>
        <div class="dialog-wrap">
            <div class='plan-detail-dialog' ref="defaultScrollTop">
                <div class='dialog_title'>プラン詳細</div>
                <p class='plan-detail-title'>
                    <span class="plan-detail-title__label">プラン名：</span>
                    <span class="plan-detail-title__name">{{planName}}</span>
                </p>
                <div class="plan-detail-wrap">
                    <table class="plan-detail-table sp_not bg-white">
                        <tr>
                            <th class="table-header-category" >分類</th>
                            <th class="table-headr-item" >項目</th>
                            <th class="table-header-detail" >詳細</th>
                        </tr>
                        <tr>
                            <td class="table-category" rowspan='6'>プレースタイル</td>
                            <td class="table-item" v-if="mealFlag !== 9">食事</td>
                            <td class="table-detail" v-if="mealFlag !== 9">{{mealFlagName}}</td>
                        </tr>
                        <tr>
                            <td class="table-item">カート</td>
                            <td class="table-detail">{{cartCodeName}}</td>
                        </tr>
                        <tr>
                            <td class="table-item">人数</td>
                            <td class="table-detail">{{player_min}}～{{player_max}}人</td>
                        </tr>
                        <tr>
                            <td class="table-item">保証</td>
                            <td class="table-detail">{{guaranteeCodeName}}</td>
                        </tr>
                        <tr>
                            <td class="table-item" v-if="caddieFlag !== 9">キャディー</td>
                            <td class="table-detail" v-if="caddieFlag !== 9">{{caddieFlagName}}</td>
                        </tr>
                        <tr>
                            <td class="table-item">ラウンド数</td>
                            <td class="table-detail">{{roundCodeName}} {{throughFlagName}}</td>
                        </tr>
                        <tr>
                            <td class="table-category" rowspan='5'>料金</td>
                        </tr>
                        <tr>
                            <td class="table-item">割増料金</td>
                            <td class="table-detail" colspan='2'>平日2サム割増：{{addFee2bWeekday}}
                                <br>平日3サム割増：{{addFee3bWeekday}}
                                <br>土日祝2サム割増：{{addFee2bWeekend}}
                                <br>土日祝3サム割増：{{addFee3bWeekend}}
                            </td>
                        </tr>
                        <tr style='height: 150px'>
                            <td class="table-category" rowspan='5'>備考</td>
                            <td class="table-detail" valign="top" colspan='2' style='white-space: pre-line;'>{{detail}}</td>
                        </tr>
                    </table>
                    <div class="table-container sp_label">
                        <div class="row">
                            <div class="table-category font-weight-bold">プレースタイル</div>
                            <div class="col-4 table-item" v-if="mealFlag !== 9">食事</div>
                            <div class="col table-detail text-right" v-if="mealFlag !== 9">{{mealFlagName}}</div>
                        </div>
                        <div class="row">
                            <div class="col-4 table-item">カート</div>
                            <div class="col table-detail text-right">{{cartCodeName}}</div>
                        </div>
                        <div class="row">
                            <div class="col-4 table-item">人数</div>
                            <div class="col table-detail text-right">{{player_min}}～{{player_max}}人</div>
                        </div>
                        <div class="row">
                            <div class="col-4 table-item">保証</div>
                            <div class="col table-detail text-right">{{guaranteeCodeName}}</div>
                        </div>
                        <div class="row">
                            <div class="col-4 table-item" v-if="caddieFlag !== 9">キャディー</div>
                            <div class="col table-detail text-right" v-if="caddieFlag !== 9">{{caddieFlagName}}</div>
                        </div>
                        <div class="row border_bottom_gray">
                            <div class="col-4 table-item">ラウンド数</div>
                            <div class="col table-detail text-right">{{roundCodeName}} {{throughFlagName}}</div>
                        </div>
                        <div class="row">
                            <div class="table-category font-weight-bold">料金</div>
                        </div>
                        <div class="row flex-column">
                            <div class="col-4 table-item">割増料金</div>
                            <div class="col table-detail" colspan='2'>平日2サム割増：{{addFee2bWeekday}}
                                <br>平日3サム割増：{{addFee3bWeekday}}
                                <br>土日祝2サム割増：{{addFee2bWeekend}}
                                <br>土日祝3サム割増：{{addFee3bWeekend}}
                            </div>
                        </div>
                        <div class="row flex-column">
                            <div class="table-category">備考</div>
                            <div class="col table-detail" style='white-space: pre-line;'>{{detail}}</div>
                        </div>
                    </div>
                </div>
                <div class="dialog-wrap__btnArea">
                    <button class="bluebackbutton dialogBtn" v-on:click="onClose">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GET_PLAN_INF } from '../../../constants/plan_master';

export default {
    components: {
    },
    data () {
        return {
            planName: null,
            mealFlag: 1,
            mealFlagName: null,
            cartCodeName: null,
            player_min: null,
            player_max: null,
            guaranteeCodeName: null,
            caddieFlag: 1,
            caddieFlagName: null,
            roundCodeName: null,
            addFee2bWeekday: null,
            addFee3bWeekday: null,
            addFee2bWeekend: null,
            addFee3bWeekend: null,
            throughFlagName: null,
            detail: null
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {

        },
        /** ----------------------------------------------
         * 画面表示処理
         * ---------------------------------------------- */
        async open(golfCode, planId) {
            this.$store.commit("loading/setIsLoading", true);
            await this.$apollo.query({
                query: GET_PLAN_INF,
                variables: {
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: golfCode,
                    plan_id: planId,
                }
            }).then(res => {
                this.setPlandetail(res.data.getPlanInf.PlanInfList[0]);
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                const message = error.message.split(':');
                this.$store.commit("loading/setIsLoading", false);
            });

        },
        /** ----------------------------------------------
         * プラン詳細設定処理
         * ---------------------------------------------- */
        setPlandetail (planInfRec) {
            this.planName = planInfRec.plan_name;
            this.mealFlag = planInfRec.meal_flag;
            this.mealFlagName = planInfRec.meal_flag_name;
            this.cartCodeName = planInfRec.cart_code_name;
            this.player_min = planInfRec.player_min;
            this.player_max = planInfRec.player_max;
            this.guaranteeCodeName = planInfRec.guarantee_code_name;
            this.caddieFlag = planInfRec.caddie_flag;
            this.caddieFlagName = planInfRec.caddie_flag_name;
            this.roundCodeName = planInfRec.round_code_name;
            if (planInfRec.add_fee_2b_weekday == null || planInfRec.add_fee_2b_weekday == 0) {
                this.addFee2bWeekday = "無し";
            } else {
                this.addFee2bWeekday = "￥" + planInfRec.add_fee_2b_weekday.toLocaleString();
            }
            if (planInfRec.add_fee_3b_weekday == null || planInfRec.add_fee_3b_weekday == 0) {
                this.addFee3bWeekday = "無し";
            } else {
                this.addFee3bWeekday = "￥" + planInfRec.add_fee_3b_weekday.toLocaleString();
            }
            if (planInfRec.add_fee_2b_weekend == null || planInfRec.add_fee_2b_weekend == 0) {
                this.addFee2bWeekend = "無し";
            } else {
                this.addFee2bWeekend = "￥" + planInfRec.add_fee_2b_weekend.toLocaleString();
            }
            if (planInfRec.add_fee_3b_weekend == null || planInfRec.add_fee_3b_weekend == 0) {
                this.addFee3bWeekend = "無し";
            } else {
                this.addFee3bWeekend = "￥" + planInfRec.add_fee_3b_weekend.toLocaleString();
            }
            if (planInfRec.through_flag !== 0 ) {
                this.throughFlagName = planInfRec.through_flag_name;
            } else {
                this.throughFlagName = "";
            }
            this.detail = planInfRec.detail;

        },
        /** ------------------------------------------------------------------
         * モーダル内のスクロール位置リセット処理
         * (閉じるボタン押下後、再度モーダルを開いた時にスクロール位置が残るのを防ぐ)
         * ------------------------------------------------------------------ */
        scrollChange () {
            this.$refs.defaultScrollTop.scrollTop = 0;
        },
        /** ----------------------------------------------
         * 閉じるボタン押下処理
         * ---------------------------------------------- */
        onClose () {
            this.$emit('closePlanDialog');
        }
    }
}

</script>

<style scoped>
.row{
    margin: 0;
}
</style>

